<script setup lang="ts">
const KeepAliveProps = {
  include: ['objects', 'events', 'animals', 'owners'],
};
</script>

<template>
  <NuxtLayout>
    <NuxtPage :keepalive="KeepAliveProps" />
  </NuxtLayout>
</template>

<style></style>
